<div class="handle-reservation" id="section">
  @if (hasEvents) {
    <ul class="cards">
      @for (el of eventsList; track el.uuid_event) {
        <li
          class="card active"
          (click)="eventSelected(el)"
        >
          <div class="header-card">
            <h3 class="card-title">
              {{
                el.event_name[userLanguage] || el.event_name[languages.default]
              }}
            </h3>

            <div class="wrap-card-img">
              @if (flux !== 'spa') {
                <img
                  class="card-img"
                  [src]="'assets/img/categorie/' + el.event_category_url"
                  [alt]="el.event_category_name"
                  [matTooltip]="el.event_category_name"
                  matTooltipPosition="above"
                />
              }
            </div>
          </div>
          <div class="card-content">
            <div class="description">
              <p>
                {{
                  el.event_short_description[userLanguage] ||
                  el.event_short_description[languages.default]
                }}
              </p>
            </div>
          </div>
          <div class="chips">
            @if (el.event_location) {
              <div class="chip">
                {{ el.event_location }}
              </div>
            }
          </div>
        </li>
      }
    </ul>
  } @else {
    <div class="title-container">
      <h2>{{ "handle_reservations.no_reservations" | translate }}</h2>
    </div>
  }
</div>
